import { render, staticRenderFns } from "./companys-add.vue?vue&type=template&id=0a61aa99&"
import script from "./companys-add.vue?vue&type=script&lang=js&"
export * from "./companys-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports